import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent {
  @Input() position: 'none' | 'center-center' | 'bottom-right' | 'bottom-left' | 'top-left' | 'top-right' = 'none';
  @Input() isLive = false;
  @Input() isBlocked = false;
  @Input() text: string;
  @Input() color: 'light' | 'dark' = 'light';
}
